module.exports = "/images/Build the log.svg";